import React from 'react';
import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
import { companyInfo } from '../data/mock';

const FloatingWhatsApp = () => {
  const openWhatsApp = () => {
    const message = encodeURIComponent("Hi, I'm interested in your IT services. Can we discuss?");
    window.open(`https://wa.me/${companyInfo.whatsapp.replace(/\+|\s/g, '')}?text=${message}`, '_blank');
  };

  return (
    <motion.button
      onClick={openWhatsApp}
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full shadow-lg flex items-center justify-center hover:shadow-xl transition-shadow group"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1, type: "spring", stiffness: 260, damping: 20 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
    >
      <MessageCircle className="text-white" size={28} />
      
      {/* Pulse animation */}
      <span className="absolute inset-0 rounded-full bg-teal-500 animate-ping opacity-20"></span>
      
      {/* Tooltip */}
      <div className="absolute right-full mr-3 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Chat on WhatsApp
        <div className="absolute top-1/2 right-0 transform translate-x-full -translate-y-1/2 border-4 border-transparent border-l-gray-900"></div>
      </div>
    </motion.button>
  );
};

export default FloatingWhatsApp;
